import instance from './instance'
import productCategoryModule from './productCategory'
import productModule from './product'

export default{
    productCategory: productCategoryModule(instance),
    product: productModule(instance)
}